(() => {
  const { dataset = {} } = document.currentScript ?? {};
  const FEATURE_KEY = 'delivery_treshold_usa';
  const FLOW_STORAGE_KEY = 'gb:deliveryTresholdUsa';
  const AB_COOKIE_NAME = 'abTestsCookie';
  const CLASS_B = 'delivery-threshold-b';

  const VARIANTS = {
    OFF: { gbValue: '0', cookieValue: 'delivery_treshold_us_off' },
    DEFAULT: { gbValue: '1', cookieValue: 'delivery_treshold_us_default' },
    B: { gbValue: '2', cookieValue: 'delivery_treshold_us_b' }
  };

  const COOKIE_OVERRIDE_VALUES = new Set(
    Object.values(VARIANTS).map(v => v.cookieValue)
  );
  const B_VARIATION_VALUES = new Set([
    VARIANTS.B.gbValue,
    VARIANTS.B.cookieValue
  ]);
  const TEST_VARIATION_VALUES = new Set([
    VARIANTS.DEFAULT.gbValue,
    VARIANTS.DEFAULT.cookieValue,
    ...B_VARIATION_VALUES
  ]);

  const getCookie = name => {
    try {
      return (
        document.cookie
          .split('; ')
          .find(row => row.startsWith(`${name}=`))
          ?.slice(name.length + 1) || null
      );
    } catch (e) {
      return null;
    }
  };

  const safeStorage = {
    get(key) {
      try {
        return localStorage.getItem(key);
      } catch (e) {
        return null;
      }
    },
    set(key, value) {
      try {
        localStorage.setItem(key, value);
      } catch (e) {}
    }
  };

  const VARIATION_SOURCES = [
    () => {
      const cookie = getCookie(AB_COOKIE_NAME);
      if (cookie && COOKIE_OVERRIDE_VALUES.has(cookie)) {
        safeStorage.set(FLOW_STORAGE_KEY, cookie);
        return cookie;
      }
      return undefined;
    },
    () => {
      const stored = safeStorage.get(FLOW_STORAGE_KEY);
      return stored != null ? String(stored) : undefined;
    },
    () =>
      window.gb
        ? String(window.gb.evalFeature(FEATURE_KEY).value ?? '')
        : undefined
  ];

  const resolveVariation = () => {
    for (const source of VARIATION_SOURCES) {
      const value = source();
      if (value !== undefined) return value;
    }
    return '';
  };

  const toThreshold = value => {
    const threshold = Number(value);
    return value != null && threshold > 0 ? threshold : null;
  };

  const resolveState = () => {
    const variation = resolveVariation();
    const defaultThreshold = toThreshold(dataset.threshold);
    const bThreshold = toThreshold(dataset.thresholdB);
    const inTest =
      defaultThreshold != null &&
      bThreshold != null &&
      TEST_VARIATION_VALUES.has(variation);
    const isB = inTest && B_VARIATION_VALUES.has(variation);
    return {
      featureKey: FEATURE_KEY,
      variation,
      inTest,
      isB,
      bThreshold,
      threshold: isB ? bThreshold : defaultThreshold
    };
  };

  const api = {
    get: () => Object.assign(api, resolveState()),
    apply: () => {
      api.get();
      document.documentElement.classList.toggle(CLASS_B, api.isB);
      if (api.threshold == null || api.bThreshold == null) return api;
      window.DELIVERY_FREE_SHIPPING_THRESHOLD = api.threshold;
      if (!document.body.classList.contains('tw-b2b')) {
        window.deliveryDisclaymer?.();
      }
      return api;
    }
  };

  const activationEnabled = 'activation' in dataset;
  let activationRequested = false;
  const requestActivation = () => {
    if (activationRequested || !activationEnabled || !api.inTest) return;
    activationRequested = true;
    if (typeof window.fireDeliveryThresholdAbActivation === 'function') {
      window.fireDeliveryThresholdAbActivation();
    } else {
      window.__pendingDeliveryThresholdAbActivation = true;
    }
  };

  const onGbSettled = () => {
    api.apply();
    requestActivation();
  };

  window.deliveryThresholdUsaAb = api;
  api.apply();
  window.gbInitPromise?.then(onGbSettled, onGbSettled);
  document.addEventListener('DOMContentLoaded', api.apply);
})();
